/**
 * @spec docs/specs/features/staking-position-ui.md#design-system
 *
 * Main layout component that wraps all pages.
 * Provides consistent header and page structure.
 */
import { Header } from './Header';
import { env } from '@/lib/env';
import { PLAY_URL } from './nav';

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * Application layout with header and main content area
 */
export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function Footer() {
  const tokenUrl = env.contracts.phnmTokenAddress
    ? `${env.baseExplorerUrl || 'https://basescan.org'}/token/${env.contracts.phnmTokenAddress}`
    : null;
  const linkClass =
    'rounded transition-colors hover:text-text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-300';

  return (
    <footer className="border-t border-white/[0.05]">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-6 text-xs text-text-muted md:flex-row md:items-center md:justify-between md:px-6">
        <p>PHNM runs on Base. Numbers update from the chain and the rewards service.</p>
        <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-5 gap-y-2">
          {tokenUrl && (
            <a href={tokenUrl} target="_blank" rel="noopener noreferrer" className={linkClass}>
              PHNM on Basescan
              <span className="sr-only"> (opens in a new tab)</span>
            </a>
          )}
          <a href={PLAY_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>
            Phenom Poker
            <span className="sr-only"> (opens in a new tab)</span>
          </a>
        </nav>
      </div>
    </footer>
  );
}
